import React, { useState, useEffect } from "react";
import moment from "moment";
import { DatePicker, message } from "antd";
import Cookies from "universal-cookie";
import { isEmpty, forEach, cloneDeep, find, filter } from "lodash";
import FilterTags from "../../componentsShared/FilterTags";
import AvgOfFacingsByRetailerChart from "../AvgOfFacingsByRetailerChart";
import NoOfFacingsByRetailer from "../NoOfFacingsByRetailer";
import {
  BACKEND_URL,
  CUSTOM_FILTER_KEYS,
  BACKEND_URL_AZURE,
} from "../../constants/constants";
import * as filterDataHanler from "../../utils/filterDataHanler";
import CustomFilter from "../../componentsShared/CustomFilter";
import { encode } from "base-64";

const ICON_ARROW_DOWN = require("../../assets/img/icons/ic-arrow-down-black.svg");
const ICON_CALENDAR = require("../../assets/img/icons/ic-calendar.svg");

const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";

const cookies = new Cookies();
let headers = new Headers({
  Authorization:
    "Basic " +
    encode(
      process.env.REACT_APP_dashboardUser +
        ":" +
        process.env.REACT_APP_dashboardPassword
    ),
  "Content-Type": "application/json",
});

let lastDate = new Date();
lastDate.setMonth(lastDate.getMonth() - 1);
lastDate = moment(lastDate).format("YYYY-MM-DD");
let currentDate = new Date();
currentDate = moment(currentDate).format("YYYY-MM-DD");

const AvgOfFacingByRetailer = ({ addLoader, removeLoader }) => {
  const [tagsData, setTagsData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [facingData, setFacingData] = useState({ chart: [], table: [] });

  if (
    localStorage.getItem("fr_startDate") &&
    localStorage.getItem("fr_startDate") !== "" &&
    localStorage.getItem("fr_startDate") !== "undefined"
  ) {
    lastDate = localStorage.getItem("fr_startDate");
  }
  if (
    localStorage.getItem("fr_endDate") &&
    localStorage.getItem("fr_endDate") !== "" &&
    localStorage.getItem("fr_endDate") !== "undefined"
  ) {
    currentDate = localStorage.getItem("fr_endDate");
  }

  if (
    !localStorage.getItem("fr_startDate") ||
    !localStorage.getItem("fr_endDate")
  ) {
    localStorage.setItem("fr_startDate", lastDate);
    localStorage.setItem("fr_endDate", currentDate);
  }

  const fetchFacing = () => {
    const loaderId = "se_avgfacingretailer";
    addLoader(loaderId);

    if (
      localStorage.getItem("fr_manufacturer") === undefined ||
      localStorage.getItem("fr_manufacturer") === "undefined" ||
      localStorage.getItem("fr_manufacturer") === "" ||
      localStorage.getItem("fr_manufacturer") === null
    ) {
      /*var strManufacturer = "";
      const manufacturers = JSON.parse(localStorage.getItem("manufacturers"));
      if (manufacturers) {
        forEach(manufacturers, (item) => {
          strManufacturer = strManufacturer + item.manufacturer_id + ",";
        });
      }
      strManufacturer = strManufacturer.substring(
        0,
        strManufacturer.length - 1
      );
      localStorage.setItem("fr_manufacturer", strManufacturer);*/
      localStorage.setItem("fr_manufacturer", "");
    }

    if (
      localStorage.getItem("fr_category") === undefined ||
      localStorage.getItem("fr_category") === "undefined" ||
      localStorage.getItem("fr_category") === "" ||
      localStorage.getItem("fr_category") === null
    ) {
      /*var strCategory = "";
      const categories = JSON.parse(localStorage.getItem("categories"));
      if (categories) {
        forEach(categories, (item) => {
          strCategory = strCategory + item.category_id + ",";
        });
      }
      strCategory = strCategory.substring(0, strCategory.length - 1);
      localStorage.setItem("fr_category", strCategory);*/
      localStorage.setItem("fr_category", "");
    }

    if (
      localStorage.getItem("fr_brand") === undefined ||
      localStorage.getItem("fr_brand") === "undefined" ||
      localStorage.getItem("fr_brand") === "" ||
      localStorage.getItem("fr_brand") === null
    ) {
      /*var strBrand = "";
      const brands = JSON.parse(localStorage.getItem("brands"));
      if (brands) {
        forEach(brands, (item) => {
          strBrand = strBrand + item.brand_id + ",";
        });
      }
      strBrand = strBrand.substring(0, strBrand.length - 1);
      localStorage.setItem("fr_brand", strBrand);*/
      localStorage.setItem("fr_brand", "");
    }

    if (
      localStorage.getItem("fr_country") === undefined ||
      localStorage.getItem("fr_country") === "undefined" ||
      localStorage.getItem("fr_country") === "" ||
      localStorage.getItem("fr_country") === null
    ) {
      var strCountry = "";
      const countries = JSON.parse(localStorage.getItem("countries"));
      if (countries) {
        forEach(countries, (item) => {
          strCountry = strCountry + item.country_id + ",";
        });
      }
      strCountry = strCountry.substring(0, strCountry.length - 1);
      localStorage.setItem("fr_country", strCountry);
    }

    if (
      localStorage.getItem("fr_region") === undefined ||
      localStorage.getItem("fr_region") === "undefined" ||
      localStorage.getItem("fr_region") === "" ||
      localStorage.getItem("fr_region") === null
    ) {
      var strRegion = "";
      const regions = JSON.parse(localStorage.getItem("regions"));
      if (regions) {
        forEach(regions, (item) => {
          strRegion = strRegion + item.region_id + ",";
        });
      }
      strRegion = strRegion.substring(0, strRegion.length - 1);
      localStorage.setItem("fr_region", strRegion);
    }

    if (
      localStorage.getItem("fr_product") === undefined ||
      localStorage.getItem("fr_product") === "undefined" ||
      localStorage.getItem("fr_product") === "" ||
      localStorage.getItem("fr_product") === null
    ) {
      /*var strProduct = "";
      const products = JSON.parse(localStorage.getItem("products"));
      if (products) {
        forEach(products, (item) => {
          strProduct = strProduct + item.product_id + ",";
        });
      }
      strProduct = strProduct.substring(0, strProduct.length - 1);
      localStorage.setItem("fr_product", strProduct);*/
      localStorage.setItem("fr_product", "");
    }

    if (
      localStorage.getItem("fr_retailer") === undefined ||
      localStorage.getItem("fr_retailer") === "undefined" ||
      localStorage.getItem("fr_retailer") === "" ||
      localStorage.getItem("fr_retailer") === null
    ) {
      var strRetailer = "";
      const retailers = JSON.parse(localStorage.getItem("retailers"));
      if (retailers) {
        forEach(retailers, (item) => {
          strRetailer = strRetailer + item.retailer_id + ",";
        });
      }
      strRetailer = strRetailer.substring(0, strRetailer.length - 1);
      localStorage.setItem("fr_retailer", strRetailer);
    }

    if (
      localStorage.getItem("fr_includePromoProducts") === undefined ||
      localStorage.getItem("fr_includePromoProducts") === "undefined" ||
      localStorage.getItem("fr_includePromoProducts") === "" ||
      localStorage.getItem("fr_includePromoProducts") === null
    ) {
      localStorage.setItem("fr_includePromoProducts", true);
    }

    if (
      localStorage.getItem("fr_includeSecondaryDisplay") === undefined ||
      localStorage.getItem("fr_includeSecondaryDisplay") === "undefined" ||
      localStorage.getItem("fr_includeSecondaryDisplay") === "" ||
      localStorage.getItem("fr_includeSecondaryDisplay") === null
    ) {
      localStorage.setItem("fr_includeSecondaryDisplay", false);
    }

    const url = `${BACKEND_URL_AZURE}/getfacingbyretailer?startDate=${localStorage.getItem(
      "fr_startDate"
    )}&endDate=${localStorage.getItem("fr_endDate")}&manufacturer=${cookies.get(
      "manufacturer"
    )}&manufacturer_filter=${localStorage.getItem(
      "fr_manufacturer"
    )}&categories=${localStorage.getItem(
      "fr_category"
    )}&brands=${localStorage.getItem(
      "fr_brand"
    )}&countries=${localStorage.getItem(
      "fr_country"
    )}&regions=${localStorage.getItem(
      "fr_region"
    )}&includePromoProducts=${localStorage.getItem(
      "fr_includePromoProducts"
    )}&products=${localStorage.getItem(
      "fr_product"
    )}&retailers=${localStorage.getItem(
      "fr_retailer"
    )}&includeSecondaryDisplay=${localStorage.getItem(
      "fr_includeSecondaryDisplay"
    )}`;

    fetch(url, { method: "GET", headers: headers })
      .then((res) => res.json())
      .then((result) => {
        removeLoader(loaderId);
        setFacingData(result);
      })
      .catch((error) => {
        console.log("--------- Error --------", error);
      });
  };

  const onHandleFilterChanged = (data) => {
    var strCategory = "";
    if (
      data.PRODUCT_CATEGORY_LIST &&
      data.PRODUCT_CATEGORY_LIST.value &&
      data.PRODUCT_CATEGORY_LIST.value.length > 0
    ) {
      for (let i = 0; i < data.PRODUCT_CATEGORY_LIST.value.length; i++) {
        strCategory =
          strCategory + data.PRODUCT_CATEGORY_LIST.value[i].id + ",";
      }
      strCategory = strCategory.substring(0, strCategory.length - 1);
      localStorage.setItem("fr_category", strCategory);
    } else {
      /*const categories = JSON.parse(localStorage.getItem("categories"));
      if (categories) {
        forEach(categories, (item) => {
          strCategory = strCategory + item.category_id + ",";
        });
      }
      strCategory = strCategory.substring(0, strCategory.length - 1);*/
      localStorage.setItem("fr_category", "");
    }

    var strBrand = "";
    if (
      data.BRAND_LIST &&
      data.BRAND_LIST.value &&
      data.BRAND_LIST.value.length > 0
    ) {
      for (let i = 0; i < data.BRAND_LIST.value.length; i++) {
        strBrand = strBrand + data.BRAND_LIST.value[i].id + ",";
      }
      strBrand = strBrand.substring(0, strBrand.length - 1);
      localStorage.setItem("fr_brand", strBrand);
    } else {
      /*const brands = JSON.parse(localStorage.getItem("brands"));
      if (brands) {
        forEach(brands, (item) => {
          strBrand = strBrand + item.brand_id + ",";
        });
      }
      strBrand = strBrand.substring(0, strBrand.length - 1);*/
      localStorage.setItem("fr_brand", "");
    }

    var strRetailer = "";
    if (
      data.RETAILER_LIST &&
      data.RETAILER_LIST.value &&
      data.RETAILER_LIST.value.length > 0
    ) {
      for (let i = 0; i < data.RETAILER_LIST.value.length; i++) {
        strRetailer = strRetailer + data.RETAILER_LIST.value[i].id + ",";
      }
      strRetailer = strRetailer.substring(0, strRetailer.length - 1);
    } else {
      const retailers = JSON.parse(localStorage.getItem("retailers"));
      if (retailers) {
        forEach(retailers, (item) => {
          strRetailer = strRetailer + item.retailer_id + ",";
        });
      }
      strRetailer = strRetailer.substring(0, strRetailer.length - 1);
    }
    localStorage.setItem("fr_retailer", strRetailer);

    var strManufacturer = "";
    if (
      data.MANUFACTURER_LIST &&
      data.MANUFACTURER_LIST.value &&
      data.MANUFACTURER_LIST.value.length > 0
    ) {
      for (let i = 0; i < data.MANUFACTURER_LIST.value.length; i++) {
        strManufacturer =
          strManufacturer + data.MANUFACTURER_LIST.value[i].id + ",";
      }
      strManufacturer = strManufacturer.substring(
        0,
        strManufacturer.length - 1
      );
      localStorage.setItem("fr_manufacturer", strManufacturer);
    } else {
      /*const manufacturers = JSON.parse(localStorage.getItem("manufacturers"));
      if (manufacturers) {
        forEach(manufacturers, (item) => {
          strManufacturer = strManufacturer + item.manufacturer_id + ",";
        });
      }
      strManufacturer = strManufacturer.substring(
        0,
        strManufacturer.length - 1
      );*/
      localStorage.setItem("fr_manufacturer", "");
    }

    var strCountry = "";
    if (
      data.COUNTRY_LIST &&
      data.COUNTRY_LIST.value &&
      data.COUNTRY_LIST.value.length > 0
    ) {
      for (let i = 0; i < data.COUNTRY_LIST.value.length; i++) {
        strCountry = strCountry + data.COUNTRY_LIST.value[i].id + ",";
      }
      strCountry = strCountry.substring(0, strCountry.length - 1);
    } else {
      const countries = JSON.parse(localStorage.getItem("countries"));
      if (countries) {
        forEach(countries, (item) => {
          strCountry = strCountry + item.country_id + ",";
        });
      }
      strCountry = strCountry.substring(0, strCountry.length - 1);
    }
    localStorage.setItem("fr_country", strCountry);

    var strRegion = "";
    if (
      data.REGION_LIST &&
      data.REGION_LIST.value &&
      data.REGION_LIST.value.length > 0
    ) {
      for (let i = 0; i < data.REGION_LIST.value.length; i++) {
        strRegion = strRegion + data.REGION_LIST.value[i].id + ",";
      }
      strRegion = strRegion.substring(0, strRegion.length - 1);
    } else {
      const regions = JSON.parse(localStorage.getItem("regions"));
      if (regions) {
        forEach(regions, (item) => {
          strRegion = strRegion + item.region_id + ",";
        });
      }
      strRegion = strRegion.substring(0, strRegion.length - 1);
    }
    localStorage.setItem("fr_region", strRegion);

if (
      data.PROMOTION_LIST.value &&
      data.PROMOTION_LIST.value !== "null" &&
      data.PROMOTION_LIST.value !== "undefined" &&
      data.PROMOTION_LIST.value.length > 0
    ) {
      const promotion = data.PROMOTION_LIST.value;
      localStorage.setItem("fr_includePromoProducts", !promotion[0].isChecked);
    } else localStorage.setItem("fr_includePromoProducts", true);

    var strProduct = "";
    if (
      data.TRACKED_PRODUCT_LIST &&
      data.TRACKED_PRODUCT_LIST.value &&
      data.TRACKED_PRODUCT_LIST.value.length > 0
    ) {
      if (
        data.TRACKED_PRODUCT_LIST.value.length ===
        JSON.parse(localStorage.getItem("products")).length
      )
        localStorage.setItem("fr_product", "");
      else {
        for (let i = 0; i < data.TRACKED_PRODUCT_LIST.value.length; i++) {
          strProduct = strProduct + data.TRACKED_PRODUCT_LIST.value[i].id + ",";
        }
        strProduct = strProduct.substring(0, strProduct.length - 1);
        localStorage.setItem("fr_product", strProduct);
      }
    } else {
      /*const products = JSON.parse(localStorage.getItem("products"));
      if (products) {
        forEach(products, (item) => {
          strProduct = strProduct + item.product_id + ",";
        });
      }
      strProduct = strProduct.substring(0, strProduct.length - 1);*/
      localStorage.setItem("fr_product", "");
    }

    if (
      data.SECONDARY_DISPLAY_SELECTION.value &&
      data.SECONDARY_DISPLAY_SELECTION.value !== "null" &&
      data.SECONDARY_DISPLAY_SELECTION.value !== "undefined" &&
      data.SECONDARY_DISPLAY_SELECTION.value.length > 0
    ) {
      const secondary = data.SECONDARY_DISPLAY_SELECTION.value;
      localStorage.setItem(
        "fr_includeSecondaryDisplay",
        secondary[0].isChecked
      );
    } else localStorage.setItem("fr_includeSecondaryDisplay", false);

    setFilterData(data);
    convertDataForTags(data);
    fetchFacing();
  };

  const convertDataForTags = (data) => {
    setTagsData(filterDataHanler.convertDataForTags(data));
  };

  const handleRemoveTag = (item) => {
    const data = filterDataHanler.removeTag(cloneDeep(filterData), item);
    setFilterData(data);
    convertDataForTags(data);

    if (item.key === "BRAND_LIST") {
      let brand = localStorage.getItem("fr_brand").split(",");
      brand = brand.filter((id) => String(id) !== String(item.checkboxId));
      localStorage.setItem("fr_brand", brand.join());
      if (brand && brand.length <= 0) {
        /*let strBrand = "";
        const brands = JSON.parse(localStorage.getItem("brands"));
        if (brands) {
          forEach(brands, (item) => {
            strBrand = strBrand + item.brand_id + ",";
          });
        }
        strBrand = strBrand.substring(0, strBrand.length - 1);
        localStorage.setItem("fr_brand", strBrand);*/
        localStorage.setItem("fr_brand", "");
      }
    }
    if (item.key === "MANUFACTURER_LIST") {
      let manufacturer = localStorage.getItem("fr_manufacturer").split(",");
      manufacturer = manufacturer.filter(
        (id) => String(id) !== String(item.checkboxId)
      );
      localStorage.setItem("fr_manufacturer", manufacturer.join());
      if (manufacturer && manufacturer.length <= 0) {
        /*let strManufacturer = "";
        const manufacturers = JSON.parse(localStorage.getItem("manufacturers"));
        if (manufacturers) {
          forEach(manufacturers, (item) => {
            strManufacturer = strManufacturer + item.manufacturer_id + ",";
          });
        }
        strManufacturer = strManufacturer.substring(
          0,
          strManufacturer.length - 1
        );
        localStorage.setItem("fr_manufacturer", strManufacturer);*/
        localStorage.setItem("fr_manufacturer", "");
      }
    }
    if (item.key === "PRODUCT_CATEGORY_LIST") {
      let category = localStorage.getItem("fr_category").split(",");
      category = category.filter(
        (id) => String(id) !== String(item.checkboxId)
      );
      localStorage.setItem("fr_category", category.join());
      if (category && category.length <= 0) {
        /*let strCategory = "";
        const categories = JSON.parse(localStorage.getItem("categories"));
        if (categories) {
          forEach(categories, (item) => {
            strCategory = strCategory + item.retailer_id + ",";
          });
        }
        strCategory = strCategory.substring(0, strCategory.length - 1);
        localStorage.setItem("fr_category", strCategory);*/
        localStorage.setItem("fr_category", "");
      }
    }
    if (item.key === "RETAILER_LIST") {
      let retailer = localStorage.getItem("fr_retailer").split(",");
      retailer = retailer.filter(
        (id) => String(id) !== String(item.checkboxId)
      );
      localStorage.setItem("fr_retailer", retailer.join());
      if (retailer && retailer.length <= 0) {
        let strRetailer = "";
        const retailers = JSON.parse(localStorage.getItem("retailers"));
        if (retailers) {
          forEach(retailers, (item) => {
            strRetailer = strRetailer + item.retailer_id + ",";
          });
        }
        strRetailer = strRetailer.substring(0, strRetailer.length - 1);
        localStorage.setItem("fr_retailer", strRetailer);
      }
    }
    if (item.key === "COUNTRY_LIST") {
      let country = localStorage.getItem("fr_country").split(",");
      country = country.filter((id) => String(id) !== String(item.checkboxId));
      localStorage.setItem("fr_country", country.join());
      if (country && country.length <= 0) {
        let strCountry = "";
        const countries = JSON.parse(localStorage.getItem("countries"));
        if (countries) {
          forEach(countries, (item) => {
            strCountry = strCountry + item.country_id + ",";
          });
        }
        strCountry = strCountry.substring(0, strCountry.length - 1);
        localStorage.setItem("fr_country", strCountry);
      }
    }
    if (item.key === "REGION_LIST") {
      let region = localStorage.getItem("fr_region").split(",");
      region = region.filter((id) => String(id) !== String(item.checkboxId));
      localStorage.setItem("fr_region", region.join());
      if (region && region.length <= 0) {
        let strRegion = "";
        const regions = JSON.parse(localStorage.getItem("brands"));
        if (regions) {
          forEach(regions, (item) => {
            strRegion = strRegion + item.region_id + ",";
          });
        }
        strRegion = strRegion.substring(0, strRegion.length - 1);
        localStorage.setItem("fr_region", strRegion);
      }
    }
    if (item.key === "PROMO_SELECTION") {
      localStorage.setItem("fr_includePromoProducts", true);
    }
    if (item.key === "TRACKED_PRODUCT_LIST") {
      let product = localStorage.getItem("fr_product").split(",");
      product = product.filter((id) => String(id) !== String(item.checkboxId));
      localStorage.setItem("fr_product", product.join());
      if (product && product.length <= 0) {
        /*let strProduct = "";
        const products = JSON.parse(localStorage.getItem("products"));
        if (products) {
          forEach(products, (item) => {
            strProduct = strProduct + item.product_id + ",";
          });
        }
        strProduct = strProduct.substring(0, strProduct.length - 1);
        localStorage.setItem("fr_product", strProduct);*/
        localStorage.setItem("fr_product", "");
      }
    }
    if (item.key === "SECONDARY_DISPLAY_SELECTION") {
      localStorage.setItem("fr_includeSecondaryDisplay", false);
    }

    fetchFacing();
  };

  useEffect(() => {
    const loaderId = "se_avgfacingretailer";
    addLoader(loaderId);
    //get all countries & regions
    let strCountry = "";
    const countries = JSON.parse(localStorage.getItem("countries"));
    if (countries) {
      forEach(countries, (item) => {
        strCountry = strCountry + item.country_id + ",";
      });
    }
    strCountry = strCountry.substring(0, strCountry.length - 1);

    let strRegion = "";
    const regions = JSON.parse(localStorage.getItem("regions"));
    if (regions) {
      forEach(regions, (item) => {
        strRegion = strRegion + item.region_id + ",";
      });
    }
    strRegion = strRegion.substring(0, strRegion.length - 1);

    let strRetailer = "";
    const retailers = JSON.parse(localStorage.getItem("retailers"));
    if (retailers) {
      forEach(retailers, (item) => {
        strRetailer = strRetailer + item.retailer_id + ",";
      });
    }
    strRetailer = strRetailer.substring(0, strRetailer.length - 1);
    //end get all countries & regions
    const url = `${BACKEND_URL_AZURE}/getfacingbyretailer?startDate=${localStorage.getItem(
      "fr_startDate"
    )}&endDate=${localStorage.getItem("fr_endDate")}&manufacturer=${cookies.get(
      "manufacturer"
    )}&countries=${strCountry}&regions=${strRegion}&retailers=${strRetailer}`;

    fetch(url, { method: "GET", headers: headers })
      .then((res) => res.json())
      .then((result) => {
        removeLoader(loaderId);
        setFacingData(result);
      })
      .catch((error) => {
        console.log("--------- Error --------", error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-100">
          <div className="Team-Activity-Overview-wp">
            <div className="title-wp">
              <div className="title-wp">Avg No. of Facings by Retailer</div>
            </div>
            <div className="condition-values-wp">
              <FilterTags data={tagsData} onRemoveTag={handleRemoveTag} />
            </div>
            <div className="control-btns">
              <div className="custom-calendar-wp" style={{ marginRight: 0 }}>
                <img className="calendar-icon" alt="" src={ICON_CALENDAR} />
                <RangePicker
                  showTime
                  format={"YYYY-MM-DD"}
                  onCalendarChange={(range, dateString, info) => {
                    let startDate = moment(range[0]).format("YYYY-MM-DD");
                    let endDate = moment(range[1]).format("YYYY-MM-DD");

                    //if (info.range === "end") {
                    localStorage.setItem("fr_startDate", startDate);
                    localStorage.setItem("fr_endDate", endDate);

                    // message.loading("loading data...", 0);
                    fetchFacing();
                    //}
                  }}
                  defaultValue={[
                    moment(lastDate, dateFormat),
                    moment(currentDate, dateFormat),
                  ]}
                  allowClear={false}
                  suffixIcon={
                    <img
                      alt=""
                      style={{ marginTop: "3px" }}
                      src={ICON_ARROW_DOWN}
                    />
                  }
                />
              </div>
              <CustomFilter
                useFilterBtnForOverview={true}
                selectedData={filterData}
                filterKeys={[
                  CUSTOM_FILTER_KEYS.COUNTRY_LIST,
                  CUSTOM_FILTER_KEYS.REGION_LIST,
                  CUSTOM_FILTER_KEYS.MANUFACTURER_LIST,
                  CUSTOM_FILTER_KEYS.TRACKED_PRODUCT_LIST,
                  CUSTOM_FILTER_KEYS.PRODUCT_CATEGORY_LIST,
                  CUSTOM_FILTER_KEYS.BRAND_LIST,
                  CUSTOM_FILTER_KEYS.RETAILER_LIST,
                  CUSTOM_FILTER_KEYS.PROMOTION_LIST,
                  CUSTOM_FILTER_KEYS.SECONDARY_DISPLAY_SELECTION,
                ]}
                onChange={(data) => {
                  onHandleFilterChanged(data);
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="separate-line mb-30" />

      <div className="row">
        <div className="col-75">
          <AvgOfFacingsByRetailerChart facingData={facingData.chart} />
        </div>
        <div className="col-25">
          <NoOfFacingsByRetailer data={facingData.table} />
        </div>
      </div>
    </>
  );
};

export default AvgOfFacingByRetailer;
